export const ADD_ARTICLE = "ADD_ARTICLE"


// WEBPACK FOOTER //
// ./src/connectors/redux/articles/actionTypes.js